import { call, put, takeLatest } from 'redux-saga/effects';

import * as linkActions from './linkActions.js';
import { deleteLinkApiCall, sortLinkApiCall, updateLinkApiCall } from './linkAPI.js';

function* updateLinkSaga({ payload }) {
  try {
    const { data } = yield call(updateLinkApiCall, payload);
    yield put(linkActions.linkUpdateLinksStore(data));
    yield put(linkActions.linkUpdateNewLink(data));
  } catch (error) {
    yield put(linkActions.linkUpdateLinksError(error.Message ? error.Message : error.toString()));
  }
}

function* deleteLinkSaga({ payload }) {
  try {
    const { id } = payload;
    yield call(deleteLinkApiCall, id);
    yield put(linkActions.linkDeleteLinksStore(id)); // update data from payload
  } catch (error) {
    console.log('deleteLinkSaga error', error.toString());
    yield put(linkActions.linkDeleteLinksError(error.Message ? error.Message : error.toString()));
  }
}

function* sortLinkSaga({ payload }) {
  try {
    yield call(sortLinkApiCall, payload);
    yield put(linkActions.linkSortLinksStore(payload));
  } catch (error) {
    yield put(linkActions.linkSortLinksError(error.Message ? error.Message : error.toString()));
  }
}

export function* linkUpdateLinksWatcher() {
  yield takeLatest(linkActions.linkUpdateLinksRequest.type, updateLinkSaga);
}

export function* linkDeleteLinksWatcher() {
  yield takeLatest(linkActions.linkDeleteLinksRequest.type, deleteLinkSaga);
}

export function* linkSortLinksWatcher() {
  yield takeLatest(linkActions.linkSortLinksRequest.type, sortLinkSaga);
}
